class Utils {
	constructor() {}

	///////////////////////////////////////////////////////////////////////////
	// Clipboard
	///////////////////////////////////////////////////////////////////////////

	// .....................................................................
	// COPY TEXT TO CLIPBOARD
	// https://gist.github.com/dgraham/cda03d4a4a528d2b4d17
	static copyText(text) {
		const node = Utils._createNode(text);
		document.body.appendChild(node);
		Utils._copyNode(node);
		document.body.removeChild(node);
	}

	static _createNode(text) {
		const node = document.createElement('pre');
		node.setAttribute('style', 'width:	1px; height:	1px; position:	fixed; top:	5px;');
		node.classList.add('select'); // Ensures that the text is selectable
		node.textContent = text;
		return node;
	}

	static _copyNode(node) {
		const selection = getSelection();
		selection.removeAllRanges();
		const range = document.createRange();
		range.selectNodeContents(node);
		selection.addRange(range);
		document.execCommand('copy');
		selection.removeAllRanges();
	}

	///////////////////////////////////////////////////////////////////////////
	// Cryptography
	///////////////////////////////////////////////////////////////////////////

	static async sha256(message) {

		// encode as UTF-8
		const msgBuffer = new TextEncoder('utf-8').encode(message);

		// hash the message
		const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

		// convert ArrayBuffer to Array
		const hashArray = Array.from(new Uint8Array(hashBuffer));

		// convert bytes to hex string
		const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');

		return hashHex;
	}

	static async sha256File(file) {

		// hash the message
		const hashBuffer = await crypto.subtle.digest('SHA-256', file);

		// convert ArrayBuffer to Array
		const hashArray = Array.from(new Uint8Array(hashBuffer));

		// convert bytes to hex string
		const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');

		return hashHex;
	}

	///////////////////////////////////////////////////////////////////////////
	// Text
	///////////////////////////////////////////////////////////////////////////

	static validateCharacter(key, valid = /([A-Za-z0-9!@#$%^&*()<>,./?;:'"{[}\]\|\-_=+`~\\\ ])/) {
		if (key === "Enter") return false;
		return (valid.test(key)) ? true :	false;
	}

	static validateText(text, valid = /(^[a-zA-Z0-9!$&\-=_+':\",.? ]*$)/) {
		if (text === '') return true;
		// console.log( 'not empty');
		// if ( /([^\n])/gm.test( text ) ) return false;
		// console.log( 'not new line');
		if (valid.test(text)) {
			return true;
		} else {
			return false;
		}
	}

	static NumToCommas(value, symbol = ',') {
		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `${symbol}`);
	}

	static NumToBitcoin( value ) {
		const commas = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `,`);
		const index = commas.lastIndexOf(',');
		return commas.substr(0, index ) + '.' + commas.substr(index + 1 );
	}

	// Track message length
	static enforceMessageLength(field, maxLength) {

		const enc = new TextEncoder('utf-8').encode(field.textContent);

		if (enc.byteLength > maxLength) {
			const slice = enc.slice(0, maxLength);
			field.textContent = new TextDecoder('utf-8').decode(slice);
			Utils.flashElement(field);
		}

		return enc.byteLength;
	}

	static StrReplaceAt( string, index, replacement) {
    	return string.substr(0, index) + replacement + string.substr(index + replacement.length);
	}

	static getStringByteSize( string ) {
		const enc = new TextEncoder('utf-8').encode( string );
		return enc.byteLength;
	}

	static validateInputField(value, field, max_length, paste = false) {
		if (value === null || typeof value === 'undefined') return field;
		if (paste)
			field += value;

		const enc = new TextEncoder('utf-8').encode(value);
		const field_text = new TextEncoder('utf-8').encode(field);

		if (field_text.byteLength > max_length) {
			const new_field = field_text.slice(0, field_text.length - enc.length);
			const text = new TextDecoder('utf-8').decode(new_field);
			field = text;
		}

		return field;
	}

	static setCaretPosition( el, caretPos ) {
		el.focus()
		let char = ( caretPos > el.textContent.length ) ? caretPos - 1 :	caretPos;
		let sel;

	    if (document.selection) {
			sel = document.selection.createRange();
			sel.moveStart( 'character', char );
			sel.select();
	    } else {
	    	sel = window.getSelection();

			// If empty set to start
			if ( el.lastChild == null ) {
				sel.collapse( el, 0 );
				return
			}

			// If at end set else set to last location
			if ( char > el.lastChild.length )
		  		sel.collapse( el.lastChild, el.lastChild.length );
			else
				sel.collapse( el.lastChild, char );
	    }
	}

	static isNavigationKey(e) {
		if (e.key === 'Backspace' 	||
			e.key === 'Delete' 		||
			e.key === 'ArrowLeft' 	||
			e.key === 'ArrowRight'	||
			e.key === 'ArrowUp' 	||
			e.key === 'ArrowDown' 	||
			e.key === 'Control' 	||
			e.key === 'Alt' 		||
			e.key === 'Home' 		||
			e.key === 'End' 		||
			e.key === 'Tab' 		||
			e.key === 'Shift' 		||
			(e.ctrlKey === true && e.key === 'x') ||
			(e.ctrlKey === true && e.key === 'c') ||
			(e.ctrlKey === true && e.key === 'v') ||
			(e.ctrlKey === true && e.key === 'a') ||
			(e.ctrlKey === true && e.key === 'z') ||
			(e.shiftKey === true && e.key === 'Insert')
		 ) {
			return true;
		} else {
			return false;
		}
	}

	static isValidEmail(email) {
		const valid = /[^@]+@[^@]+\.[^@]+/g;
		if (valid.test(email)) {
			return true
		} else {
			return false
		}

	}

	static parsePixelPreimage( pstr ) {
		console.log(pstr);
		const x_coord_str =			pstr.slice(17,21);
		const y_coord_str =			pstr.slice(21,25);
		const price_str =			pstr.slice(31,40);

		return {
			version_str:			pstr.slice(0,1),
			art_checksum_id_str:	pstr.slice(1,17),
			x_coord_str:			x_coord_str,
			x_coord_int:			parseInt("0x" + x_coord_str),
			y_coord_str:			y_coord_str,
			y_coord_int:			parseInt("0x" + y_coord_str),
			rgb_str:				pstr.slice(25,31),
			red_str:				pstr.slice(25,27),
			green_str:				pstr.slice(27,29),
			blue_str:				pstr.slice(29,31),
			price_str:				price_str,
			price_int:				parseInt("0x" + price_str),
			salt_str:				pstr.slice(40,64),
		}
	}

	static selectRange(el) {
		const range = document.createRange();
		range.selectNodeContents(el);
		const sel = window.getSelection();
		sel.removeAllRanges();
		sel.addRange(range);
	}

	///////////////////////////////////////////////////////////////////////////
	// Graphic
	///////////////////////////////////////////////////////////////////////////

	static createCanvasTextTexture(data) {
		// Create Canvas Element for custom texture
		const canvas = document.createElement('canvas');
		canvas.width = data.width;
		canvas.height = data.height;
		// canvas.id       = data.text;

		const ctx = canvas.getContext('2d');
		ctx.fillStyle = `#${data.bgcolor}`;
		ctx.fillRect(0, 0, canvas.width, canvas.height);
		ctx.font = `${data.fontsize}pt ${data.font}`;
		ctx.fillStyle = `#${data.fgcolor}`;
		ctx.textAlign = data.align;
		const x = (data.align === 'center') ? data.width / 2 :	data.padleft;
		if (data.wrap) {
			wrapText(ctx, data.text, x, data.fontsize + data.padtop, data.width - 15, data.fontsize + 2);
		} else {
			ctx.fillText(data.text, x, data.fontsize + data.padtop);
		}

		return canvas;
		return new THREE.CanvasTexture(canvas);
	}

	static base64ToTexture(base64) {

	}

	static UpdateImageData(data, canvas) {
		const ctx = canvas.getContext('2d');
		const num_entries = data.coords.length;
		// array.forEach( pixel => {
		for (let i = 0; i < num_entries; i++) {
			// locate pixel to change
			// 4 color pixel
			// one line array
			const color = Utils.hex2rgb(("000000" + data.colors[i].toString(16)).substr(-6));
			const buffer = new Uint8ClampedArray([
				color[0],
				color[1],
				color[2],
				[255]
			]);
			const flipY = canvas.height - data.coords[i].y - 1;
			const imageData = new ImageData(buffer, 1, 1);
			ctx.putImageData(imageData, data.coords[i].x, flipY);
		}

		return ctx;
	}

	static hex2rgb(str) {
		str = str.replace('#', '');
		return str.split('').reduce(function (result, char, index, array) {
			var j = parseInt(index * 3 / array.length);
			var number = parseInt(char, 16);
			result[j] = (array.length == 3 ? number :	result[j]) * 16 + number;
			return result;
		}, [0, 0, 0]);
	}

	static isOdd(num) {
		return num % 2;
	}

	static imageLoader(url) {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.src = url;
			img.onload = () => {
				resolve(img);
			};
			img.onerror = reject;
		});
	}

	/**
	 * Checks if file is valid png
	 * @param {Uint8Array}  file - An instance of the file data
	 * @return {boolean}    returns state
	 */
	static isValidPNG(file) {
		const png = [137, 80, 78, 71];
		return this.isValidateFileType(file, png);
	}

	///////////////////////////////////////////////////////////////////////////
	// Files
	///////////////////////////////////////////////////////////////////////////

	static loadFileAsArrayBuffer(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsArrayBuffer(file);
			reader.onload = e => resolve(e.target.result);
			reader.onerror = e => reject('Cannot load file');
		});
	}

	static loadFileAsDataUrl(file) {
		// console.log( `Loading:	File`);
		// console.log( file );
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = e => resolve(e.target.result);
			reader.onerror = e => reject('Cannot load file');
		});
	}

	static loadTextFile(file) {
		console.log(`Loading:	${file}`);
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsText(file);
			reader.onload = e => resolve(e.target.result);
			reader.onerror = e => reject('Cannot load file');
		});
	}

	static loadTextFileFromURL(file, destinationEl) {
		fetch(file)
			.then(res => {
				if (res.status === 200) {
					return res.text();
				} else {
					throw new Error('Ack failed to load file')
				}
			})
			.then(text => {
				destinationEl.textContent = text;
			})
			.catch(error => {
				throw new Error('Ack failed to load file')
			});
	}

	static loadImage(base64) {
		return new Promise((resolve, reject) => {
			const image = new Image();
			image.src = base64;
			image.onload = () => resolve(image)
			image.onerror = () => reject('Cannot load image');
		});
	}

	/**
	 * Checks file size against value
	 * @param  {Object}    file - File
	 * @param  {Integer}   maxSize - File size
	 * @return {boolean}   returns state
	 */
	static isValidateFileSize(file, maxSize) {
		if (file.size < maxSize) {
			return true;
		} else {
			return false;
		}
	}

	/**
	 * Checks if file is valid based on header bytes
	 * @param {Uint8Array}  file     An instance of the file data
	 * @param {array}       type     A Uint8Array of header bytes
	 */
	static isValidateFileType(file, type) {
		for (let i = 0; i < type.length; i++) {
			if (file[i] !== type[i]) return false;
		}

		return true;
	}

	static export_to_file( data, filename, type = "text/plain" ) {
		if ( !data ) { console.error("export_to_file: Missing Data"); }
		if ( typeof(filename) !== "string" ) { console.error("export_to_file: Missing filename"); }
		if ( typeof(type) !== "string" ) { console.error("export_to_file: bad type"); }

		const link = document.createElement("a");
		link.href = URL.createObjectURL(new Blob([data], { type: type }));
		link.setAttribute("download", filename );
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	///////////////////////////////////////////////////////////////////////////
	// CSS
	///////////////////////////////////////////////////////////////////////////

	static flashElement(el, color = 'red') {
		if (el.classList.contains(`flash-${color}`)) return;
		el.classList.add(`flash-${color}`);
		setTimeout(() => {
			el.classList.remove(`flash-${color}`);
		}, 500);
	}

	///////////////////////////////////////////////////////////////////////////////
	// utility:
	///////////////////////////////////////////////////////////////////////////////

	static buf2hex(buffer) {
		return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
	}

	static buf2string(dv, start, end) {
		let s = "";
		let i = 0;

		while ((dv.getUint8(start + i) != 0) && (i < 256) && (i < (end - start))) {
			s += String.fromCharCode(dv.getUint8(start + i));
			i++;
		}
		return s;
	}

	static utf8buf2string(decoder, dv, start, end) {
		let buf = new Uint8Array(end - start);
		let i = 0;

		while ((dv.getUint8(start + i) != 0) && (i < 256) && (i < (end - start))) {
			buf[i] = dv.getUint8(start + i);
			i++;
		}
		buf[i] = 0;
		return decoder.decode(buf);
	}

	static utf8tag2string(decoder, dv, start, end) {
		let buf = new Uint8Array(end - start);
		let i = 0;

		while ((dv.getUint8(start + i) != 0) && (i < 256) && (i < (end - start))) {
			buf[i] = dv.getUint8(start + i);
			i++;
		}
		buf[i] = 0;
		let decoded = decoder.decode(buf);
		return decoded.substr(0, decoded.indexOf('\0'));
	}

	static printHex(dv, start, n) {
		let s = "";
		for (let i = 0; i < n; i++) {
			let b = dv.getUint8(start + i);
			s += ('00' + b.toString(16)).slice(-2);
		}
		console.log(s);
	}

	static three2int(high, mid, low) {
		return (high << 16) | (mid << 8) | low;
	}

	static highIntC(dv, start) {
		const high = dv.getUint8(start);
		const mid = dv.getUint8(start + 1);
		const low = dv.getUint8(start + 2);

		return (Utils.three2int(high, mid, low) & 0x0ffc00) >> 10;
	}

	static lowIntC(dv, start) {
		const high = dv.getUint8(start);
		const mid = dv.getUint8(start + 1);
		const low = dv.getUint8(start + 2);
		return (Utils.three2int(high, mid, low) & 0x0003ff);
	}

	static intM(dv, start) {
		const high = dv.getUint8(start);
		const mid = dv.getUint8(start + 1);
		const low = dv.getUint8(start + 2);
		//console.log(high + " " + mid + " " + low);
		return ((high & 0x0f) << 16) | (mid << 8) | low
	}

	static intS(dv, start) {
		const first = dv.getUint8(start);
		const second = dv.getUint8(start + 1);
		const third = dv.getUint8(start + 2);
		const fourth = dv.getUint8(start + 3);
		const fifth = dv.getUint8(start + 4);

		return (((first & 0x0f) << 32) | (second << 24) | (third << 16) |
			(fourth << 8) | fifth);
	}

	static int8(dv, start) {
		const first = dv.getUint8(start);
		const second = dv.getUint8(start + 1);
		const third = dv.getUint8(start + 2);
		const fourth = dv.getUint8(start + 3);
		const fifth = dv.getUint8(start + 4);
		const sixth = dv.getUint8(start + 5);
		const seventh = dv.getUint8(start + 6);
		const eighth = dv.getUint8(start + 7);

		return ((first << 56) | (second << 48) | (third << 40) | (fourth << 32) |
			(fifth << 24) | (sixth << 16) | (seventh << 8) | (eighth));
	}

	static int4(dv, start) {
		const first = dv.getUint8(start);
		const second = dv.getUint8(start + 1);
		const third = dv.getUint8(start + 2);
		const fourth = dv.getUint8(start + 3);
		return (first << 24) | (second << 16) | (third << 8) | (fourth);
	}

	static int5(dv, start) {
		const first = dv.getUint8(start);
		const second = dv.getUint8(start + 1);
		const third = dv.getUint8(start + 2);
		const fourth = dv.getUint8(start + 3);
		const fifth = dv.getUint8(start + 4);
		return ((first << 32) | (second << 24) | (third << 16) |
			(fourth << 8) | (fifth));
	}

	static isNumWithinTolerance( numA, numB, tolerance ) {
		if ( numB >= numA - tolerance && numB <= numA + tolerance ) {
			return true;
		} else {
			return false;
		}
	}

	static time_converter( timestamp ){
	    const newDate = new Date();
	    newDate.setTime(timestamp*1000);
	    return newDate.toUTCString();
	}

	///////////////////////////////////////////////////////////////////////////////
	// utility:
	///////////////////////////////////////////////////////////////////////////////

	static isKeyChar( code ) {
		const list = {
			"Backspace": false,
			"Tab": false,
			"Enter": false,
			"Shift": false,
			"Ctrl": false,
			"Control": false,
			"Delete": false,
			"Alt": false,
			"Pause/Break": false,
			"Caps Lock": false,
			"CapsLock": false,
			"Esc": false,
			"Page Up": false,
			"Page Down": false,
			"PageUp": false,
			"PageDown": false,
			"End": false,
			"Home": false,
			"NumLock": false,
			"ArrowRight": false,
			"ArrowLeft": false,
			"ArrowUp": false,
			"ArrowDown": false,
		}
		return ( list[code] !== undefined ) ?  list[code] : true;
	}

	static isNewLineChar( key ) {
		if ( !key ) return;
		if ( key === "Enter" || key === "Return") {
			return true;
		} else {
			return false;
		}
	}

	static mobileCheck() {
		var check = false;
	    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	    return check;
		};

	static limitInputToType( field, e, restrictionType ) {
		// Restrict user input in a text field
		// create as many regular expressions here as you need:
		let charList;
		switch (restrictionType) {
			case 'digitsOnly': 	charList = /[1234567890]/g;    break;
			case 'integerOnly': charList = /[0-9\.]/g; 		   break;
			case 'alphaOnly': 	charList = /[A-Za-z]/g; 	   break;
			case 'usernameOnly':charList = /[0-9A-Za-z\._-]/g; break;
			default: 			charList = /[1234567890]/g;    break;
		}

		// Allow navigation
		if (e.key === "Backspace" ||
			e.key === "Delete" ||
			e.key === "ArrowLeft" ||
			e.key === "ArrowRight" ||
			e.key === "ArrowUp" ||
			e.key === "ArrowDown" ||
			e.key === "Control" ||
			e.key === "Alt" ||
			e.key === "Home" ||
			e.key === "End" ||
			e.key === "Tab" ||
			e.key === "Insert" ||
			e.key === "Shift" ) {
			return true;
		}

		// Allow Cut + Paste + copy + undo + redo
		if (e.ctrlKey && (e.key === "v" ||
						  e.key === "x" ||
						  e.key === "c" ||
						  e.key === "y" ||
						  e.key === "z")) return true;

		// if user pressed esc... remove focus from field...
		if (e.key === "Escape") { field.blur(); return false; }

		// Check against restricted keys
		if (e.key.match(charList)) {
			return true;
		} else {
			return false;
		}
	}

	static disabled_field_input( field ) {
		if (!field) return;

		field.classList.add('disabled');
		field.contentEditable = false;
	}

	static enable_field_input( field ) {
		if (!field) return;

		field.classList.remove('disabled');
		field.contentEditable = true;
	}

	static convert_to_boolean( value ) {
		switch ( typeof(value) ) {
			case "string":
				if ( value.toLowerCase() === "false" ) {
					return false;
				} else if ( value.toLowerCase() === "true" ) {
					return true;
				} else {
					return null;
				}
				break;
			case "boolean":
				return value;
				break;
			case "number":
				if ( value === 0 ) {
					return false;
				} else if ( value === 1 ) {
					return true;
				} else {
					return null;
				}
				break;
			default:
				return null

		}
	}

	static makeid(length) {
	   let result             = '';
	   const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	   for ( let i = 0; i < length; i++ ) {
	      result += characters.charAt(Math.floor(Math.random() * characters.length));
	   }
	   return result;
	}

	static convertNumberRange( value, og_min, og_max, dest_min, dest_max ) {
		return ( value - og_min ) * ( dest_max - dest_min ) / ( og_max - og_min ) + dest_min;
	}

	///////////////////////////////////////////////////////////////////////////////
	// Timing:
	///////////////////////////////////////////////////////////////////////////////

	static debounce(func, time) {
		let timeout;
		return function () {
			const functionCall = () => func.apply(this, arguments);

			clearTimeout(timeout);
			timeout = setTimeout(functionCall, time);
		}
	}

	///////////////////////////////////////////////////////////////////////////////
	// Bitcoin:
	///////////////////////////////////////////////////////////////////////////////

	/**
	 * Checks the Bitcoin Address to ensure it's a valid type
	 * Won't be able to confirm if it's a real address however
	 * TODO:	Write address validator
	 * @param  {String}    address     Bitcoin address
	 * @return {boolean}   returns state
	 */
	static isValidBitcoinAddress(address) {
		if (address.length > 0 && address.length <= 64 )
			return true
		else
			return false;
	}

	/**
	 * Checks the Signed Messages to ensure it's a valid type
	 * TODO:	Write signed message validator
	 * @param  {String}    signature     Signed message
	 * @return {boolean}   returns state
	 */
	static isValidSignedMessage(signature) {
		if (signature.length > 0 && signature.length <= 256 )
			return true
		else
			return false;
	}
}

exports.Utils = Utils;

// https://www.html5canvastutorials.com/tutorials/html5-canvas-wrap-text-tutorial/
function wrapText(context, text, x, y, maxWidth, lineHeight) {
	const words = text.split(' ');
	let line = '';

	for (let n = 0; n < words.length; n++) {
		const testLine = line + words[n] + ' ';
		const metrics = context.measureText(testLine);
		const testWidth = metrics.width;
		if (testWidth > maxWidth && n > 0) {
			context.fillText(line, x, y);
			line = words[n] + ' ';
			y += lineHeight;
		} else {
			line = testLine;
		}
	}
	context.fillText(line, x, y);
}
